import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import TitleSection from "src/components/TitleSection/TitleSection";

const RespectfulEnvironment = () => {
  const { t } = useTranslation();
  return (
    <RespectfulEnvironmentDiv>
      <container-div>
        <TitleSection title={t("respectful-environment.re-title")}/>
        <p>{t("respectful-environment.re-text")}</p>
      </container-div>
    </RespectfulEnvironmentDiv>
  );
};

const RespectfulEnvironmentDiv = styled.div`
  height: fit-content;
  width: 100%;
  background: var(--lightblack);
  padding: 140px 0;
  color: var(--mutedwhite);
  p:last-child {
    padding-top: 2rem;
  }
`;
export default RespectfulEnvironment;
